module.exports = __webpack_public_path__ + "static/media/pic4.eac7776a.jpg";